function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "contrast"
}, React.createElement("path", {
  fill: "#0E426B",
  d: "M96.544,3.456v93.088H3.456V3.456H96.544 M100,0H0v100h100V0L100,0z"
}), React.createElement("circle", {
  opacity: 0.57,
  fill: "#009AD7",
  enableBackground: "new    ",
  cx: 50.104,
  cy: 21.012,
  r: 9.474
}), React.createElement("circle", {
  fill: "none",
  stroke: "#009AD7",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  cx: 50.146,
  cy: 21.012,
  r: 9.474
}), React.createElement("line", {
  fill: "none",
  stroke: "#009AD7",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 46.636,
  y1: 12.264,
  x2: 46.636,
  y2: 29.972
}), React.createElement("line", {
  fill: "none",
  stroke: "#009AD7",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 50.146,
  y1: 11.59,
  x2: 50.146,
  y2: 30.538
}), React.createElement("line", {
  fill: "none",
  stroke: "#009AD7",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 53.653,
  y1: 12.426,
  x2: 53.653,
  y2: 29.481
}), React.createElement("circle", {
  opacity: 0.57,
  fill: "#0E426B",
  enableBackground: "new    ",
  cx: 21.193,
  cy: 50.056,
  r: 9.474
}), React.createElement("circle", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  cx: 21.235,
  cy: 50.056,
  r: 9.474
}), React.createElement("line", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 17.684,
  y1: 41.272,
  x2: 17.684,
  y2: 58.964
}), React.createElement("line", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 21.193,
  y1: 40.582,
  x2: 21.193,
  y2: 59.53
}), React.createElement("line", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 24.701,
  y1: 41.417,
  x2: 24.701,
  y2: 58.855
}), React.createElement("circle", {
  opacity: 0.57,
  fill: "#0E426B",
  enableBackground: "new    ",
  cx: 78.892,
  cy: 50.056,
  r: 9.474
}), React.createElement("circle", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  cx: 78.932,
  cy: 50.056,
  r: 9.474
}), React.createElement("line", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 75.382,
  y1: 41.272,
  x2: 75.382,
  y2: 58.964
}), React.createElement("line", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 78.892,
  y1: 40.582,
  x2: 78.892,
  y2: 59.53
}), React.createElement("line", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 82.399,
  y1: 41.417,
  x2: 82.399,
  y2: 58.855
}), React.createElement("circle", {
  opacity: 0.57,
  fill: "#0E426B",
  enableBackground: "new    ",
  cx: 50.084,
  cy: 79.101,
  r: 9.474
}), React.createElement("circle", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  cx: 50.124,
  cy: 79.101,
  r: 9.474
}), React.createElement("line", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 46.574,
  y1: 70.316,
  x2: 46.574,
  y2: 88.008
}), React.createElement("line", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 50.084,
  y1: 69.627,
  x2: 50.084,
  y2: 88.574
}), React.createElement("line", {
  fill: "none",
  stroke: "#0E426B",
  strokeWidth: 2.305,
  strokeMiterlimit: 10,
  x1: 53.591,
  y1: 70.463,
  x2: 53.591,
  y2: 87.902
}));

var SvgContrastSensitivity = function SvgContrastSensitivity(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "contrast",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgContrastSensitivity, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ContrastSensitivity.a33bdb58.svg";
export { ForwardRef as ReactComponent };